import * as PropTypes from "prop-types";
import * as React from "react";

import Result from "src/models/result";
import Item from "./Item";

import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";

const styles = (theme: Theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

export interface IProps extends WithStyles<typeof styles> {
  results: Result[];
}

class ResultsGrid extends React.Component<IProps, any> {
  public render() {
    const items = this.props.results.map((result: Result, i: number) => (
      <Item result={result} key={i} />
    ));

    return <div>{items}</div>;
  }
}

(ResultsGrid as React.ComponentClass<IProps>).propTypes = {
  classes: PropTypes.object.isRequired
} as any;

export default withStyles(styles)(ResultsGrid);



// WEBPACK FOOTER //
// ./src/components/Dashboard/ResultsGrid.tsx